import { AspectTypes, GalleryImage } from 'models'

export interface ImageGalleryEditorInitProps {
  onClose: () => void
  images: GalleryImage[]
  setImages: (images: GalleryImage[]) => void
  indexOnFocus: number
  additionalProps?: any
}

export interface CropValues {
  x: number
  y: number
}

export interface CroppedAreaPixels extends CropValues {
  width: number
  height: number
}

export const defaultCropValues: CropValues = {
  x: 1,
  y: 1
}

export const aspectRatioValues = {
  [AspectTypes.PORTRAIT]: 0.7,
  [AspectTypes.SQUARE]: 1
}
